import gates, {GATE_NAME} from "config/gates";

interface GateCallbackArgs {
  settings: any
  tenant: any
  user: any
}

export type GateCallbackFunction = (a: GateCallbackArgs) => boolean;

export class ParametersManager {

  public gates = GATE_NAME

  // eslint-disable-next-line no-useless-constructor
  constructor(
    private user: any,
    private settings: any,
    private tenant: any) {
  }

  get(resource: string): any{
    return this.settings[resource] || this.tenant[resource]
  }

  /**
   * Return true if current user is allowed to access
   */
  allows(resource: GATE_NAME): boolean{
    const callback: GateCallbackFunction | undefined = gates.get(resource)
    if(!callback) return false
    return callback({tenant: this.tenant, settings: this.settings, user: this.user})
  }

  has(resource: GATE_NAME): boolean{
    return this.allows(resource)
  }

  /**
   * Return false if current user is denied to access
   */
  denies(resource: GATE_NAME): boolean{
    return !this.allows(resource)
  }
}
